<script>
import ChatScreen from '@/src/router/views/safehaven/chat/chat-screen.vue'
import WaitScreen from '@src/router/views/safehaven/chat/wait-screen.vue'
import { chatComputed } from '@state/chatHelper'
import { mapGetters } from 'vuex'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { providerChatService } from '../services/safehaven/ProviderChatService'
export default {
  components: { ChatScreen, WaitScreen },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      dialogDetails: '',
      component: '',
      dialog: false,
      minimize: true,
    }
  },
  computed: {
    ...chatComputed,
    ...mapGetters({ openDialog: 'getChatDialogStatus' }),
    openDialog: {
      get() {
        return this.getChatDialogStatus
          ? this.getChatDialogStatus.dialog
          : this.getChatDialogStatus
      },
      set(newVal) {
        return newVal
      },
    },
    showComponent() {
      if (this.getChatDialogStatus) {
        return this.getChatDialogStatus.component
      } else {
        return null
      }
    },
    minimizeClass() {
      return this.minimize
        ? this.$style.displayDialog
        : this.$style.hiddenDialog
    },
    background() {
      return this.minimize
        ? this.$style.blueBackground
        : this.$style.whiteBackground
    },
  },
  mounted() {
    if (this.getChatDialogStatus) {
      this.dialogDetails = this.getChatDialogStatus
      this.component = this.dialogDetails.component
      this.dialog = this.dialogDetails.dialog
      // eslint-disable-next-line no-unneeded-ternary
      document.getElementsByTagName('body')[0].className =
        this.dialog && this.dialog !== '' ? 'noscroll' : ''
    }
  },
  methods: {
    minimizeDialog() {
      this.minimize = !this.minimize
    },
    endChat() {
      if (this.$store.state.chat.patientProviderDetails) {
        providerChatService.onDisconnect()
      }
      this.$store.dispatch('chat/setChatDialogStatus', {
        component: '',
        dialog: false,
      })
      document.body.removeAttribute('class', 'noscroll')
      this.minimize = true
      this.navigateToScreen('end-secure-chat-screen')
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="openDialog"
    elevation-1
    attach="body"
    max-width="400"
    persistent
    no-click-animation
    scrollable
    :hide-overlay="minimize ? false : true"
    overlay-opacity="0.1"
    :content-class="
      'elevation-0' + ' ' + $style.dialogMenu + ' ' + minimizeClass
    "
    :fullscreen="mobile"
  >
    <v-card :class="[$style.dialogContainer, background]">
      <v-card-title :class="$style.chatHeader">
        <v-row no-gutters>
          <v-col
            class="clickable"
            cols="6"
            :class="$style.minimizeSecureChatText"
          >
            <span v-if="minimize" @click="minimizeDialog">Minimize</span>
            <span v-if="!minimize" @click="minimizeDialog">Expand</span>
          </v-col>

          <v-col
            class="clickable"
            cols="6"
            align="right"
            :class="$style.endSecureChatText"
          >
            <span @click="endChat">Close Chat</span>
          </v-col>
        </v-row>
      </v-card-title>
      <ChatScreen v-if="showComponent === 'Chat' && minimize"></ChatScreen>
      <WaitScreen v-if="showComponent === 'Wait' && minimize"></WaitScreen>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  font-family: $system-default-font-family;
  background: #fff;
  border: 0;
  border-radius: 9px !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.displayDialog {
  position: absolute;
  animation: showChat ease-in 50ms;
}

.hiddenDialog {
  position: fixed;
  top: unset !important;
  right: 0;
  bottom: -28px;
  width: 400px;
  height: auto !important;
  overflow: hidden;
  animation: hideChat ease-out 50ms;
}
/* stylelint-disable */
@keyframes hideChat {
  from {
    top: 40%;
    right: 20%;
  }
  to {
    top: calc(100vh - 15vh);
    right: 0;
  }
}

@keyframes showChat {
  from {
    top: calc(100vh - 15vh);
    right: 0%;
  }
  to {
    top: 40%;
    right: 20%;
  }
}
/* stylelint-enable */

.dialogContainer {
  display: inline-block;
  height: 100% !important;
  padding: 0;
  border: 0;
  box-shadow: none !important;
}

.blueBackground {
  background-color: #f2f9ff !important;
}

.whiteBackground {
  background-color: #fff !important;
}
.chatHeader {
  padding: 0;
  background-color: #fff !important;
}
.endSecureChatText {
  font-size: 15px;
  font-weight: 400;
  color: #0476d9;
  letter-spacing: 0;
}

.minimizeSecureChatText {
  font-size: 15px;
  font-weight: 400;
  color: #0476d9;
  letter-spacing: 0;
}
.minimizeSecureChatText span {
  cursor: pointer;
}

@media screen and (max-width: 599px) {
  /* stylelint-disable */
  .hiddenDialog {
    position: fixed;
    top: unset !important;
    bottom: 0px !important;
    right: 0;
    width: 100%;
    overflow: hidden;
    animation: hideChat ease-out 50ms;
  }
}
</style>

<style scoped>
/deep/ .v-dialog > .v-card > .v-card__title {
  padding: 3px 10px;
}
/* stylelint-enable */
</style>
